import request from "@src/util/request";
import { API_CF_LOGIN, API_BASE_DATA, API_BASE_AREA_DATA, API_HOLIDAY_VALIDATE, API_CF_UPLOAD, API_TEL } from "@src/config/api";
import store from '@src/util/store'
import {isEmpty} from "@src/util";
import { SOURCE } from '@src/config'
/**
 * 登录
 */
 export function login(token?: string) {
  const login = store.getUser()
  if (login?.id) {
      return new Promise(resolve => resolve(login))
  } else {
      const form = new FormData()
      if (token) {
        form.append('zhUserToken', token)
      }
      return request.post(API_CF_LOGIN,
          form,
          {headers: {contentType: 'application/x-www-form-urlencoded'}}).then((rs:any) => {
          const response = rs.data
          const {data, errcode, errmsg} = response
          if (errcode != 0) {
              throw `login err: ${String(errmsg)}`
          }
          store.setUser(data)
          return data
      })
  }
}

/**
 * 获取联系电话
 * @returns 
 */
export function getPhoneNumber(){
    if (store.get('phone')) {
        return new Promise<void>((resolve) => {
            resolve(store.get('phone'))
        })
    }
    return request.get(API_TEL, {params: {source: SOURCE}}).then(rs=>{
        const response = rs.data
            const {data, errcode, errmsg} = response
            if (errcode != 0) {
                throw `data err: ${String(errmsg)}`
            }
            store.set('phone', data)
            return data
    })
}

/**
 * 获取所有基础配置数据
 * uri: data/all
 */
export function getBaseData() {
    const baseConfigData = store.get('basics')
    if (!baseConfigData) {
        return request.post(API_BASE_DATA).then(rs => {
            const response = rs.data
            const {data, errcode, errmsg} = response
            if (errcode != 0) {
                throw `data err: ${String(errmsg)}`
            }
            store.set('basics', data)
            return data
        })
    } else {
        return new Promise((resolve) => resolve(baseConfigData))
    }
}
/**
 * 获取区域数据
 * @returns 
 */
export function getBaseAreaData() {
    let baseConfigAreaData = [] 
    try { 
        baseConfigAreaData = store.get('area')
    } catch (error) {
        baseConfigAreaData = []
    }
    if (!baseConfigAreaData || !baseConfigAreaData.length) {
        return request.post(API_BASE_AREA_DATA).then(rs => {
            const response = rs.data
            const {data, errcode, errmsg} = response
            if (errcode != 0) {
                throw `data err: ${String(errmsg)}`
            }
            store.set('area', data)
            return data
        })
    } else {
        const dataObj = baseConfigAreaData
        return new Promise((resolve) => resolve(dataObj))
    }
}
// 判定是否假日停办业务
export function validateHoliday(){
    return request.get(API_HOLIDAY_VALIDATE).then(rs=>rs.data)
}

/**
 * 上传文件
 * @param file
 */
 export function uploadFile(file: any) {
    const form = new FormData()
    form.append('file', file)
    return request.post(API_CF_UPLOAD, form).then(rs => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}